import { Link } from "wouter";
import { BookOpen } from "lucide-react";

export function Footer() {
  return (
    <footer className="border-t border-border bg-card">
      <div className="max-w-7xl mx-auto px-6 py-10 flex flex-col sm:flex-row items-center justify-between gap-6">
        <div className="flex items-center gap-2">
          <div className="w-7 h-7 rounded-lg bg-gradient-to-br from-primary to-accent flex items-center justify-center">
            <BookOpen className="w-3.5 h-3.5 text-white" />
          </div>
          <span className="font-display font-bold text-sm text-foreground">Lerni</span>
        </div>

        <p className="text-xs text-muted-foreground hidden sm:block">
          © {new Date().getFullYear()} Lerni. All rights reserved.
        </p>

        <div className="flex items-center gap-6">
          <nav className="flex items-center gap-5 text-xs text-muted-foreground">
            <Link href="/privacy" className="hover:text-foreground transition-colors">Privacy</Link>
            <Link href="/terms" className="hover:text-foreground transition-colors">Terms</Link>
            <Link href="/refund" className="hover:text-foreground transition-colors">Refund</Link>
            <Link href="/cookies" className="hover:text-foreground transition-colors">Cookies</Link>
          </nav>

          <div className="w-px h-6 bg-border hidden sm:block" />

          <a
            href="mailto:lernisupport@gmail.com"
            className="flex flex-col items-start group"
          >
            <span className="text-[10px] text-muted-foreground/60 uppercase tracking-wider leading-none mb-0.5">
              Need support?
            </span>
            <span className="text-xs font-semibold text-primary group-hover:text-primary/70 transition-colors">
              Contact Us
            </span>
          </a>
        </div>

        <p className="text-xs text-muted-foreground sm:hidden">
          © {new Date().getFullYear()} Lerni. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
